const headerStyle = (theme) => ({

  headerBar: {
    background: theme.palette.headerBgColor.color,
    // zIndex: '1301',
    boxShadow: '0 0 2px rgba(0,0,0,.3)',
    height: 60,
  },
  rootToolbar: {
    justifyContent: 'flex-end',
    minHeight: 'inherit',
    '@media (max-width:767px)': {
      paddingLeft: 8,
      paddingRight: 0,
    },
  },
  logoUpDiv: {
    width: '250px',
    background: '#242738',
    position: 'absolute',
    height: '100%',
    left: '0px',
    '@media (max-width:550px)': {
      width: '190px',
    },
  },
  logoUpDivDark: {
    width: '250px',
    background: '#ECECEC',
    position: 'absolute',
    left: '0px',
  },
  logoImg: {
    width: '230px',
    marginLeft: 4,
    height: 60,
    position: 'relative',
    left: 52,
    display: 'flex',
    alignItems: 'center',
    top: 2,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      // '@media (max-width:550px)':{
      //     display:"none",
      // },
    },
    '@media (max-width:767px)': {
      margin: 0,
      width: '160px',
      height: 'auto',

      top: -4,
    },
    '@media (min-width:768px) and (max-width:1024px)': {
      margin: 0,
      left: 50,
    },
  },
  headerRightBlock: {

    display: 'flex',
    height: 60,
    '& .cipDashboard': {
      color: theme.palette.modalTextColor.color,
      height: 35,
      borderRadius: 5,
      alignItems: 'center',
      display: 'flex',
      alignSelf: 'center',
      width: 50,
      justifyContent: 'center',
      position: 'relative',
      marginRight: 0,
      transition: '0.3s all linear',
      '& .switchPlatform': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& svg': {
          fill: theme.palette.modalTextColor.color,
          transition: '0.3s all linear',
          width: 20,
          height: 20,
        },
      },
      '&:hover': {
        cursor: 'pointer',
      },
      '@media (max-width:767px)': {
        width: 30,
        height: 30,
        '& .switchPlatform': {
          '& svg': {
            width: 18,
            height: 18,
          },
        },
      },

    },

    '& button': {
      display: 'flex',
      alignSelf: 'center',
      width: 50,
      height: 45,
      marginLeft: 0,
      minWidth: 'inherit',
      borderRadius: 0,
      borderRight: `1px solid ${theme.palette.headerBorder.color}`,
      color: theme.palette.colorSet.color,
      '@media (max-width:400px)': {
        width: 40,
      },
      '@media (max-width:330px)': {
        width: 30,
      },
      '& svg.Brightness2Icon': {
        transform: 'rotate(170deg)',
        fontSize: '1.2rem!important',
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& > span': {
        width: '100%',
        height: '100%',
        justifyContent: 'inherit',
        display: 'flex',
        '& img': {
          width: '20px',
        },
      },
    },

    '@media (max-width:767px)': {
      '& button': {
        minWidth: 40,
        '& .MuiAvatar-circle': {
          width: 30,
          height: 30,
        },
      },
    },
    '@media (max-width:550px)': {
      '& button': {
        width: '35px',
        minWidth: 30,
        padding: '3px 8px',
      },
    },

  },
  Brightness2Icon: {
    '& svg': {
      width: '25px',
      fill: `${theme.palette.modalTextColor.color} !important`,
      transform: 'rotate(170deg)',
      fontSize: '1.2rem!important',
    },
  },
  languageBt: {
    width: '79px!important',
    '@media (max-width:550px)': {
      width: '74px!important',
    },
    '& img': {
      width: '23px!Important',
      borderRadius: '20px',
    },
    '& span:nth-child(1)': {
      borderRadius: '20px',
      width: '92px!Important',
      border: `1px solid${theme.palette.secondary.borderColors}`,
      padding: '0px 6px 0px 4px',
      justifyContent: 'space-between',
    },
    '& svg': {
      width: '8px',
    },
    '& .spanlang': {
      borderLeft: `1px solid${theme.palette.secondary.borderColors}`,
      paddingLeft: '5px',
      '& svg': {
        fill: theme.palette.secondary.svgCol,
      },
    },
  },

  headerNotificationBadge: {
    '& span': {
      background: '#189b54',
      color: '#FFF',
    },
  },
  linkColor: {
    color: theme.palette.secondary.contrastText,
  },
  userName: {
    marginLeft: 0,
    textTransform: 'capitalize',
    fontWeight: 400,
  },
  switchTheme: {
    width: 50,
    float: 'right',
    margin: '20px 0 0 35px',
    position: 'relative',
  },
  switchIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    zIndex: 9,
  },
  removePaddingTB: {
    padding: '0 10px',
  },
  subMenuDropdown: {
    top: '45px !important',
  },
  profileBtn: {
    background: 'none !important',
    borderRight: '0 !important',
    '& .MuiAvatar-root': {
      width: '19px!important',
      height: '19px!important',

    },
    '& div': {
      color: theme.palette.modalTextColor.color,
    },
    '& img': {
      // width:'100% !important',
      objectFit: 'contain',
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
  menuDropdown: {
    position: 'relative',
    '& div:nth-child(3)': {
      top: '62px !important',
      backgroundColor: theme.palette.platform.color,
      '& ul': {
        padding: 0,
        '& li': {
          padding: '15px 18px',
          borderBottom: `1px solid ${theme.palette.counterBorder.color}`,
          '&:last-child': {
            borderBottom: 0,
          },
          '& svg': {
            fontSize: 20,
            width: 24,
            height: 24,
            marginRight: 15,
            fill: theme.palette.modalTextColor.color,
          },
        },
      },
    },
    '& div:nth-child(2)': {
      transition: 'unset !important',
      transform: 'none !important',
      transformOrigin: 'unset !important',
    },
  },
  flagDropdown: {
    '& div:nth-child(3)': {
      width: '170px',
      '& ul': {
        padding: 0,
        '& li': {
          padding: '8px 16px',
          '&:nth-child(1)': {
            borderBottom: `1px solid ${theme.palette.counterBorder.color}`,
          },
        },
      },
    },
    '& div:nth-child(2)': {
      transition: 'unset !important',
      transform: 'none !important',
      transformOrigin: 'unset !important',
    },
  },
  flagIcon: {
    width: '32px',
    marginRight: '12px',
    pointerEvents: 'none',
  },
  notificationMain: {
    '& .MuiDrawer-paperAnchorRight': {
      background: theme.palette.modalTextColor.MainCol,
    },
  },
  notificationListHeading: {

    // borderBottom: "1px solid #DDD",
    display: 'flex',
    padding: '16px 0px',
    paddingLeft: '27px',
    paddingRight: '8px',
    alignItems: 'center',
    background: theme.palette.modalTextColor.bgSet,
    '& img': {
      marginRight: '5px',
      width: '20px',
      height: '20px',
      filter: theme.palette.modalTextColor.filter,
    },
    '& h3': {
      margin: '0px',
      // paddingBottom: "15px",
      marginRight: 'auto',
      fontWeight: '100',
      fontSize: '15px',
    },
    '& svg': {
      fontSize: '1.8em',
      margin: '5px',
      padding: '10px',
      borderRadius: '50%',
    },
    '& :hover svg': {
      background: 'rgba(0, 0, 0, 0.04)',
    },
    '& .notificationListHeadIcon': {
      marginRight: '5px',
      cursor: 'pointer',
      display: 'flex',
    },
  },
  notificationList: {
    minWidth: '350px',
    // marginTop: '60px',
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: '0px',
      '& li': {
        display: 'flex',
        // borderLeft:"3px solid #339933",
        padding: '6px 0px',
        borderBottom: `1px solid${theme.palette.modalTextColor.borderColor}`,
        alignItems: 'center',
        '& a': {
          padding: '10px 15px',
        },
      },
      '& li .unread': {
        background: '#00c300',
        width: '4px',
        height: '50px',
        margin: 'auto',
      },
      '& li:hover': {
        backgroundColor: 'rgba(125, 125, 125, 0.3)',
      },
    },
    '& .notification-detail': {
      marginRight: 'auto',
      width: '280px',
    },
    '& .notification-title': {
      marginBottom: '7px',
      color: theme.palette.modalTextColor.color,
      fontSize: '12px!important',
      fontWeight: '100',
    },
    '& .notification-time': {
      marginRight: 'auto',
      color: ' #9F9F9F',
      fontSize: '9px',
    },
    '& .notification-actions': {
      position: 'relative',
      width: '50px',
      height: '50px',
      marginTop: '7px',
      '&.notification-actions:before': {
        position: 'absolute',
        width: '5px',
        height: '5px',
        borderRadius: '20px',
        background: '#00c300',
        content: "''",
        left: '50%',
        transform: 'translate(-50%, 0px)',
      },
      '& svg': {
        width: '30px',
        height: '30px',
        padding: '4px',
        borderRadius: '50%',
      },
      '& :hover': {
        background: 'rgba(0, 0, 0, 0.04)',
        cursor: 'pointer',
      },
    },
    '@media (max-width:767px)': {
      minWidth: '320px !important',
      '& .notification-title': {
        fontSize: '0.8em !important',
      },
      '& .notification-time': {
        fontSize: '0.7em !important',
      },
      '& .notification-detail': {
        width: '250px !important',
      },
      '& ul li a': {
        padding: '5px 10px !important',
      },
    },
  },
  cipDashboardDropdown: {
    width: 280,
    right: 0,
    left: 'auto',
    zIndex: 99999,
    top: 50,
    backgroundColor: theme.palette.platform.color,
    position: 'absolute',
    maxHeight: 0,
    minHeight: 0,
    overflow: 'hidden',
    borderRadius: 0,
    transition: '0.3s linear',
    '& ul': {
      padding: 0,
      listStyle: 'none',
      margin: 0,
      '& li': {
        borderBottom: `1px solid ${theme.palette.counterBorder.color}`,
        '&:last-child': {
          borderBottom: '1px solid transparent',
        },
      },
      '& .mainLinks': {
        color: theme.palette.modalTextColor.color,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        padding: '0 15px',
        textDecoration: 'none',
        position: 'relative',
        '& .links': {
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          '& div': {
            display: 'flex',
            flexDirection: 'column',
            '& p': {
              color: theme.palette.modalTextColor.color,
              margin: 0,
              fontSize: 20,
              fontWeight: 700,
              '& span': {
                display: 'inline-block',
                fontSize: 15,
                fontWeight: 'normal',
              },
            },
            '& > span': {
              color: '#0065f7',
              display: 'inline-block',
              fontSize: 13,
              transform: 'scaleY(0.9)',
              fontWeight: 'bold',
              lineHeight: 1,
              textTransform: 'uppercase',
            },
          },
          '& img': {
            width: '100%',
          },
          '& span': {
            margin: 0,
            fontSize: 14,
            color: theme.palette.modalTextColor.color,
          },
        },
        '&:hover': {
          background: theme.palette.secondary.light,
          color: theme.palette.modalTextColor.color,
        },
      },
    },
  },
  cipOpen: {
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    maxHeight: '460px',
    minHeight: 47,
    transition: '0.3s linear',
  },
});

export default headerStyle;
